/* __next_internal_client_entry_do_not_use__ default,useTranslation auto */ import { useEffect, useState } from "react";
import i18next from "i18next";
import { initReactI18next, useTranslation as useTranslationOrg } from "react-i18next";
import { useCookies } from "react-cookie";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getOptions, languages, cookieName } from "./settings";
const runsOnServerSide = "object" === "undefined";
const i18nOptions = {
    ...getOptions(),
    lng: undefined,
    detection: {
        order: [
            "path",
            "htmlTag",
            "cookie",
            "navigator"
        ]
    },
    preload: runsOnServerSide ? languages : []
};
i18next.use(initReactI18next).use(LanguageDetector).use(resourcesToBackend((language, namespace)=>import("./locales/".concat(language, "/").concat(namespace, ".json")))).init(i18nOptions);
export default i18next;
export function useTranslation(lng, ns, options) {
    const [cookies, setCookie] = useCookies([
        cookieName
    ]);
    const ret = useTranslationOrg(ns, options);
    const { i18n } = ret;
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);
    if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
        i18n.changeLanguage(lng);
    }
    useEffect(()=>{
        if (activeLng === i18n.resolvedLanguage) return;
        setActiveLng(i18n.resolvedLanguage);
    }, [
        activeLng,
        i18n.resolvedLanguage
    ]);
    useEffect(()=>{
        if (!lng || i18n.resolvedLanguage === lng) return;
        i18n.changeLanguage(lng);
    }, [
        lng,
        i18n
    ]);
    useEffect(()=>{
        if (cookies.i18next === lng) return;
        setCookie(cookieName, lng, {
            path: "/"
        });
    }, [
        lng,
        cookies.i18next
    ]);
    return ret;
}
